@let recordingsValue = recordings();

@if (recordingsValue && recordingsValue.length > 0) {
  <ng-container *transloco="let t; prefix: 'shared.rec'">
    <button id="nav-rec-button" mat-icon-button type="button" [matMenuTriggerFor]="recordingMenu">
      <mat-icon svgIcon="circle" />
      {{ t('inProgress') }}
    </button>

    <mat-menu #recordingMenu="matMenu" class="rec-menu" [overlapTrigger]="false">
      @for (rec of recordingsValue; track rec.projectAndSessionName) {
        @if ($index > 0) {
          <mat-divider />
        }

        <button
          class="recording-title"
          mat-menu-item
          type="button"
          [matMenuTriggerData]="{ rec: rec }"
          [matMenuTriggerFor]="recordingActionsMenu"
        >
          {{ rec.projectAndSessionName }} /
          <span>{{ rec.recordingStartedAt | elapsedTime }}</span>
        </button>
      }
    </mat-menu>

    <mat-menu #recordingActionsMenu="matMenu">
      <ng-template let-rec="rec" matMenuContent>
        <button mat-menu-item type="button" [routerLink]="rec.sessionNavigationLink">
          <span>{{ t('jumpToSession') }}</span>
        </button>

        <button mat-menu-item routerLink="staff-monitor" type="button" [queryParams]="rec.staffMonitorQueryParams">
          {{ t('staffMonitor') }}
        </button>
      </ng-template>
    </mat-menu>
  </ng-container>
}
